import { render, staticRenderFns } from "./fzxsjList.vue?vue&type=template&id=76c952af&scoped=true&"
import script from "./fzxsjList.vue?vue&type=script&lang=js&"
export * from "./fzxsjList.vue?vue&type=script&lang=js&"
import style0 from "./fzxsjList.vue?vue&type=style&index=0&id=76c952af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c952af",
  null
  
)

export default component.exports